import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.shipper',
    field: 'shipper',
    width: 120,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.name',
    field: 'name',
    width: 320,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.phone',
    field: 'phone',
    width: 180,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.contact',
    field: 'contact',
    width: 160,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.state',
    field: 'state',
    width: 80,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.shipperstatusabbrev',
    field: 'shipperstatusabbrev',
    width: 80,
  },

  // end of default columns

  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.addr1',
    field: 'addr1',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.addr2',
    field: 'addr2',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.city',
    field: 'city',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },

  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.postalcode',
    field: 'postalcode',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.countrycode',
    field: 'countrycode',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },

  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.fax',
    field: 'fax',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.email',
    field: 'email',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.shipperstatus',
    field: 'shipperstatus',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },

  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.lastuser',
    field: 'lastuser',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.lastupdate',
    field: 'lastupdate',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'shipment.supplier_lookup_dialog.grid.columns.custid',
    field: 'custid',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
];
